jQuery(function ($) {
    if ($('.count-animation').length === 0) {
        return;
    }

    function animateCount($element) {
        const targetCount = parseInt($element.data('count'), 10); // Get the target count from data attribute
        if (isNaN(targetCount)) {
            console.warn('Invalid data-count value for:', $element);
            return;
        }

        // Save the original width of the element
        const originalWidth = $element.width();
        $element.css({
            width: originalWidth + 'px', // Fix the width to the original value
            display: 'inline-block', // Ensure the width applies correctly
        });

        $({ count: 0 }).animate(
            { count: targetCount },
            {
                duration: 1500, // Animation duration
                easing: 'swing',
                step: function (now) {
                    $element.text(Math.floor(now)); // Update element text with the current value
                },
                complete: function () {
                    $element.text(targetCount); // Ensure the final value is displayed
                },
            }
        );
    }

    // Monitor when the class .count-animation is added to elements
    const observer = new MutationObserver(function (mutationsList) {
        mutationsList.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = $(mutation.target);
                if (target.hasClass('count-animation')) {
                    animateCount(target);
                }
            }
        });
    });

    // Animate immediately for elements with the class already present
    $('.count-animation').each(function () {
        animateCount($(this));
    });

    // Observe for new elements being added dynamically
    $('[data-count]').each(function () {
        observer.observe(this, { attributes: true });
    });
});
